<template>
  <v-tooltip left>
    <template v-slot:activator="{ on }">
      <v-chip
        v-on="on"
        dark
        :class="{
          teal: visible,
          red: !visible,
        }"
      >
        {{ visible ? "Visible" : "No visible" }}
      </v-chip>
    </template>
    <p v-html="messages"></p>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    this.isVisibleInApp();
    this.setVisibilityMessages();
  },
  data() {
    return {
      familyHasSubCategories: false,
      productHasSubcategory: false,
      messages: "",
      visible: false,
    };
  },
  watch: {
    product: {
      handler: function () {
        this.isVisibleInApp();
        this.setVisibilityMessages();
      },
      deep: true,
    },
  },
  methods: {
    isVisibleInApp() {
      if (0 < this.product.familia.subfamilias_count) {
        this.familyHasSubCategories = true;
        if (null !== this.product.subfamilia) {
          this.productHasSubcategory = true;
        } else {
          this.visible = false;
          return;
        }
      } else {
        if (1 === this.product.activo) {
          this.visible = true;
        }
        return;
      }

      this.visible =
        this.familyHasSubCategories &&
        this.productHasSubcategory &&
        1 === this.product.activo &&
        true === this.product.familia.activo &&
        true === this.product.subfamilia.activo
          ? true
          : false;
    },
    setVisibilityMessages() {
      let messages = "";

      if (0 == this.product.activo) {
        messages += "Active este producto.</br>";
      }
      if (false === this.product.familia.activo) {
        messages +=
          "Active la categoría " + this.product.familia.nombre + "</br>";
      }
      if (
        true === this.productHasSubcategory &&
        false === this.product.subfamilia.activo
      ) {
        messages +=
          "Active la Sub-categoría " + this.product.subfamilia.nombre + "</br>";
      }
      if (this.familyHasSubCategories && !this.productHasSubcategory) {
        messages += "Asigne una subcategoría al producto.</br>";
      }

      if (0 === messages.length) {
        messages += "Ninguna acción necesaria.";
      }
      this.messages = messages;
    },
  },
};
</script>

<style>
</style>